import { PrestigeManager } from '@/systems/PrestigeManager';
import { BuildingManager } from '@/systems/BuildingManager';
import { formatNumber } from '@/utils/format';

export class PrestigePanel {
  private container: HTMLElement;
  private progressEl: HTMLElement;
  private progressBar: HTMLElement;
  private infoEl: HTMLElement;
  private btn: HTMLButtonElement;
  private onPrestige: () => void;

  constructor(parent: HTMLElement, onPrestige: () => void) {
    this.onPrestige = onPrestige;

    this.container = document.createElement('div');
    this.container.id = 'prestige-panel';
    this.container.className = 'game-panel';
    this.container.style.textAlign = 'center';

    this.container.innerHTML = `
      <div class="game-panel-header">
        <div class="game-panel-title">ASCENSION</div>
        <button class="game-panel-close">&times;</button>
      </div>
      <div id="prestige-info" style="font-size: 11px; color: var(--text-dim); margin-bottom: 12px;"></div>
      <div class="progress-bar">
        <div id="prestige-bar" class="progress-fill" style="width: 0%;"></div>
      </div>
      <div id="prestige-progress" style="font-size: 11px; color: var(--text-dim); margin-bottom: 12px;"></div>
    `;

    this.btn = document.createElement('button');
    this.btn.className = 'btn btn-upgrade';
    this.btn.textContent = '⬆ ASCEND';
    this.btn.style.cssText = 'width: 100%; padding: 12px; font-size: 14px;';
    this.btn.addEventListener('click', () => this.onPrestige());
    this.container.appendChild(this.btn);

    this.progressEl = this.container.querySelector('#prestige-progress')!;
    this.progressBar = this.container.querySelector('#prestige-bar')!;
    this.infoEl = this.container.querySelector('#prestige-info')!;
    this.container.querySelector('.game-panel-close')!.addEventListener('click', () => this.hide());

    parent.appendChild(this.container);
  }

  update(prestige: PrestigeManager, buildings: BuildingManager): void {
    const progress = prestige.getProgressToPrestige(buildings);
    const canPrestige = prestige.canPrestige(buildings);
    const currentEra = prestige.getCurrentEra();
    const nextEra = prestige.getNextEra();

    this.progressBar.style.width = `${Math.min(100, progress * 100)}%`;
    this.progressEl.textContent = `${formatNumber(buildings.getTotalProductionRate())} / ${formatNumber(currentEra.productionThreshold)} /s`;

    if (nextEra) {
      this.infoEl.textContent = `${currentEra.name} → ${nextEra.name} (x${currentEra.prestigeMultiplier} multiplier)`;
    } else {
      this.infoEl.textContent = `${currentEra.name} — Max era reached`;
    }

    this.btn.disabled = !canPrestige;
    this.btn.style.opacity = canPrestige ? '1' : '0.4';
  }

  show(): void {
    this.container.style.display = 'block';
  }

  hide(): void {
    this.container.style.display = 'none';
  }

  toggle(): void {
    if (this.container.style.display === 'none') {
      this.show();
    } else {
      this.hide();
    }
  }

  destroy(): void {
    this.container.remove();
  }
}
